import { useEffect } from 'react';
import { POPUP_CLOSE_EVENT } from './popupGlobalRegistry';

/**
 * Escucha el cierre coordinado entre popups (`closeOtherPopups` dispara el evento por id).
 */
export function usePopupCloseEventSubscription(params: {
  popupUniqueId: string;
  closePopup: () => void;
}): void {
  const { popupUniqueId, closePopup } = params;

  useEffect(() => {
    const onCloseRequest = (e: Event) => {
      const id = (e as CustomEvent<{ id: string }>).detail?.id;
      if (id === popupUniqueId) {
        closePopup();
      }
    };
    document.addEventListener(POPUP_CLOSE_EVENT, onCloseRequest);
    return () => document.removeEventListener(POPUP_CLOSE_EVENT, onCloseRequest);
  }, [popupUniqueId, closePopup]);
}
